import TopicsBox from "../TopicsBox";
import { formatDate, readingTime } from "../../common/format";

import { useEffect } from "react";

function ArticleHeader(props) {
    const { title, topics, date, slug } = props;

    useEffect(() => {
        document.title = title;
    }, [title]);

    return (
        <header className="article-content">
            <h1 className="article-content" >
                {title}
            </h1>
            <p className="article-meta">{formatDate(date)} · {readingTime(slug)}</p>
            <TopicsBox topics={topics} />
        </header>
    );
}

export default ArticleHeader;
